module.exports = __webpack_public_path__ + "img/pause1.dc723dca.png";